import IntegrationCallListModelBase from '../_generated/modelBases/integration-call-list-model-base';

export default class IntegrationCallListModel extends IntegrationCallListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
